export const insertAfter = (newNode, referenceNode) => {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
};

export const getClosest = (elem, selector) => {
  let originalElem = elem;

  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.matchesSelector
      || Element.prototype.mozMatchesSelector
      || Element.prototype.msMatchesSelector
      || Element.prototype.oMatchesSelector
      || Element.prototype.webkitMatchesSelector
      || function matchesSelector(s) {
        const matches = (window.document || window.ownerDocument).querySelectorAll(s);
        let i = matches.length;

        while (i >= 0 && matches.item(i) !== this) {
          i -= 1;
        }

        return i > -1;
      };
  }

  // Get closest match
  for (; originalElem && originalElem !== document; originalElem = originalElem.parentNode) {
    if (originalElem.matches(selector)) return originalElem;
  }

  return null;
};
